import React from 'react';
import {ReactSortable} from 'react-sortablejs';
import {FieldArray} from 'formik';
import {LanguageId} from '../../../models/utils/Languages';
import IconListMove from '../../icon/IconListMove';
import UIInput from '../../../ui/form/UIInput';
import DeleteIcon from '../../../ui/DeleteIcon';
import UILink from '../../../ui/UILink';

type OptionsListProps = {
  language: LanguageId
  initialValues: string[]
}

export default function OptionsList({language, initialValues}: OptionsListProps) {
  const fieldName = optName(language);
  return (
    <FieldArray name={fieldName}>
      {({remove, push, swap}) => (
        <div>
          {initialValues.length > 0 &&
            <ReactSortable list={initialValues.map((x, index) => ({id: index, name: x}))}
              setList={() => 1}
              handle=".sort-handle" animation={200} direction="vertical"
              ghostClass="block-sortable-ghost" dragClass="block-sortable-drag"
              forceFallback={true}
              onEnd={((evt) => evt.oldIndex !== undefined && evt.newIndex !== undefined && swap(evt.oldIndex, evt.newIndex))}>
              {initialValues.map((value, index) =>
                <div className="grid grid-cols-12" key={`${fieldName}.${index}`}>
                  <IconListMove className="sort-handle hover:cursor-pointer mr-2 mt-5"/>
                  <div className="col-span-10">
                    <UIInput name={`${fieldName}.${index}`} id={`${fieldName}.${index}`}/>
                  </div>
                  {index !== 0 &&
                  <DeleteIcon title="Delete translation" onDelete={() => remove(index)} alwaysVisible={true}
                    className="ml-2 mt-4"/>
                  }
                  {index === 0 && <div/>}
                </div>)
              }
            </ReactSortable>
          }
          <UILink href="#" onClick={() => push('')} className="mt-2 block">Add option</UILink>
        </div>
      )}
    </FieldArray>
  );
}

export function optName(langId: LanguageId): string {
  return `options_${langId}`;
}
